export const defaultTranslateFn = (key) => key;
//# sourceMappingURL=TranslationUtilities.js.map